<h2>{{name}}</h2>
<hr/>
<p>
  A component that enables the selection of a date/time for the desired timezone.
  <br/>

  This component is composed of <strong>jb-dropdown</strong>, <strong>jb-date-picker</strong> and the <a href="https://ng-bootstrap.github.io/#/components/dropdown/examples">Angular bootstrap dropdown</a>

  <br/>
  Please note that the locale and list of supported timezones will need to be suplied to the consuming application.
</p>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>

<div class="whiteBg">
  <div class="row">
    <div class="col-5 marB15">
      <h5 class="marB25">jb-time-picker Customizations:</h5>
      <jb-time-picker
        [jbSelectedTime]="defaultStartDate"
        [(jbSelectedTimezone)]="defaultTimezone"
        [jbSupportedTimezones]="supportedTimezones"
        [jbDisabled]="compConf.isDisabled"
        [jbMinTime]="compConf.minTime"
        [jbMaxTime]="compConf.maxTime">
      </jb-time-picker>
      <div class="code-box pad15 marT15">
        <pre>{{customCompCode}}</pre>
      </div>
    </div>

    <div class="col-6">
      <div class="row marT15">
        <div class="col-2 padT5">
          <jb-checkbox [(ngModel)]="compConf.isDisabled" (ngModelChange)="upComp()" jbLabel="Is Disabled"></jb-checkbox>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-4 padT5">
          <jb-dropdown class="full-width"
                       [(ngModel)]="compConf.jbLocale"
                       [jbList]="localesList" (ngModelChange)="upComp()"
                       jbLabel="Locale"
                       jbSelect="code"
                       jbRender="name">
          </jb-dropdown>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-5">
          <jb-time-picker jbLabel="Min Datetime" [(jbSelectedTime)]="compConf.minTime" [(jbSelectedTimezone)]="defaultTimezone" [jbSupportedTimezones]="supportedTimezones" [jbMaxTime]="compConf.maxTime" (jbSelectedTimeChange)="upComp()"></jb-time-picker>
        </div>
      </div>

      <div class="row marT15">
        <div class="col-5">
          <jb-time-picker jbLabel="Max Datetime" [(jbSelectedTime)]="compConf.maxTime" [(jbSelectedTimezone)]="defaultTimezone" [jbSupportedTimezones]="supportedTimezones" [jbMinTime]="compConf.minTime" (jbSelectedTimeChange)="upComp()" ></jb-time-picker>
        </div>
      </div>
    </div>
  </div>
</div>

<hr/>
<h5 class="mt-4">Examples: </h5>
<div class="row">
  <div class="col-12 examples-table">
    <div class="row">
      <div class="col-5">
        <jb-time-picker [jbSelectedTimezone]="'Europe/Dublin'" [jbSupportedTimezones]="[{ country_code: null, time_zone: 'Europe/Dublin' }, { country_code: null, time_zone: 'US/Arizona' }]"></jb-time-picker>
      </div>
      <div class="col-7">
        <div class="code-box">
          <pre>{{instance}}</pre>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-5">
        <jb-time-picker
          [(jbSelectedTime)]="defaultStartDate"
          [(jbSelectedTimezone)]="defaultTimezone"
          [jbMinTime]="minTime"
          [jbMaxTime]="maxTime"
          [jbSupportedTimezones]="supportedTimezones"
        ></jb-time-picker>
      </div>
      <div class="col-7">
        <div class="code-box">
          <pre>{{instance2}}</pre>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-5">
        <jb-time-picker
          jbLabel="Disabled"
          [(jbSelectedTime)]="defaultStartDate"
          [(jbSelectedTimezone)]="defaultTimezone"
          [jbMinTime]="minTime"
          [jbMaxTime]="maxTime"
          [jbSupportedTimezones]="supportedTimezones"
          [jbDisabled]="true"
        ></jb-time-picker>
      </div>
      <div class="col-7">
        <div class="code-box">
          <pre>{{instance3}}</pre>
        </div>
      </div>
    </div>
  </div>
</div>
